// extracted by mini-css-extract-plugin
export default {"grid":"CardList_grid__xAPXY"};